import { INTEGRATION_STATUS } from '../../integrations/constants';
class NpsScoreController {
  constructor(Authentication, PersonaCollection, IntegrationService, $timeout) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection, IntegrationService, $timeout });
  }

  $onInit() {
    this.user = null;
    this.init();
  }

  async init() {
    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;

    this.hasShopifyIntegration = false;
    if (this.Authentication.user.isOrgCreator) {
      const shopifyIntegration = await this.IntegrationService.getIntegrationByPlatform('shopify');
      this.hasShopifyIntegration = shopifyIntegration.status === INTEGRATION_STATUS.ENABLED;
    }

    await this.$timeout(3000);

    this.user = this.Authentication.user;
    this.saveClientFlags = this.Authentication.saveClientFlags;
  }
}

export default {
  template: `
    <r-external-rate ng-if="!!ctrl.user"
      user="ctrl.user"
      save-client-flags="ctrl.saveClientFlags(flags)"
      has-shopify-integration="ctrl.hasShopifyIntegration">
    </r-external-rate>
    `,
  controller: NpsScoreController,
  controllerAs: 'ctrl',
};
